import { render, staticRenderFns } from "./RadialSearchResultsView.vue?vue&type=template&id=0ffd2f94&scoped=true&"
import script from "./RadialSearchResultsView.vue?vue&type=script&lang=js&"
export * from "./RadialSearchResultsView.vue?vue&type=script&lang=js&"
import style0 from "./RadialSearchResultsView.vue?vue&type=style&index=0&id=0ffd2f94&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ffd2f94",
  null
  
)

/* custom blocks */
import block0 from "./RadialSearchResultsView.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports